(() => {
  const selector = [
    '.damper-product-bridge[data-damper-article-cta] a[href*="/products/period-balance"]',
    'a[data-damper-article-cta-link][href*="/products/period-balance"]',
  ].join(',');

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) {
      return;
    }

    const link = event.target.closest(selector);

    if (!link) {
      return;
    }

    const bridge = link.closest('[data-damper-article-cta]');
    const pathParts = window.location.pathname.split('/').filter(Boolean);
    const payload = {
      article_handle: pathParts.at(-1) || '',
      article_path: window.location.pathname,
      cta_variant:
        bridge?.dataset.damperArticleCta ||
        link.dataset.damperArticleCtaLink ||
        'article',
      destination: new URL(link.href, window.location.origin).pathname,
      link_text: link.textContent.trim().replace(/\s+/g, ' ').slice(0, 100),
    };

    if (window.Shopify?.analytics?.publish) {
      try {
        const publication = window.Shopify.analytics.publish(
          'article_cta_click',
          payload
        );

        if (publication && typeof publication.catch === 'function') {
          publication.catch(() => {});
        }
      } catch {}
    }

    document.dispatchEvent(
      new CustomEvent('damper:article-cta-click', { detail: payload })
    );
  });
})();
